import React, { useEffect, useState, useRef } from 'react'
import CrudTable from '../../crud/CrudTable'
import {
    rentService as service,
    carService,
    billService,
    suscriptoorService,
} from '../../../services'
import FileDownloadIcon from '@mui/icons-material/PictureAsPdfOutlined'
import { Button, Grid } from '@mui/material'
import { panelSuscription } from '../../utils/Utils'
import PanelSus from '../../sus/PanelSus'

const moment = require('moment')

// FilterSuscriptionRental del backend: car, user, from, to, state (SuscriptionState).
// No existen campos modality ni paymentState en el filtro: añadirlos sería engañoso.
const initFilter = {
    car: null,
    user: null,
    from: null,
    to: null,
    state: null,
}

export default function Rent() {
    const createEstructureFilter = [
        {
            type: 'input',
            name: 'from',
            inputtype: 'date',
            col: 4,
        },
        {
            type: 'input',
            name: 'to',
            inputtype: 'date',
            col: 4,
        },
        {
            type: 'autocomplete',
            name: 'state',
            col: 4,
            options: [
                { key: 'PENDINGACCEPT', name: 'Pendiente de aceptación' },
                { key: 'ACCEPT', name: 'Aceptado' },
                { key: 'PROBLEMFIANCE', name: 'Problema con la preautorización' },
                { key: 'START', name: 'Iniciado' },
                { key: 'END', name: 'Finalizado' },
                { key: 'CANCEL', name: 'Cancelado' },
            ],
        },
    ]

    const paintCell = {
        seguro: (value, object) => {
            return value ? (
                <>
                    <img src="/ic_secbig.png" style={{ width: '30px' }} />
                    <br />
                </>
            ) : (
                <></>
            )
        },
        modality: (value, object) => {
            if (value == 'RENT') {
                return <span style={{ fontWeight: 'bold' }}>RENT</span>
            } else if (value == 'XARENT') {
                return <span style={{ fontWeight: 'bold' }}>XARENT</span>
            } else {
                return <></>
            }
        },
        total: (value, object) => {
            return <>{value ? (+value).toFixed(2) : '0.00'} €</>
        },
        km_real: (value, object) => {
            return <>{value ? value.toFixed(2) : 0} Km</>
        },
        paymentState: (value, object) => {
            if (value == 'NONE') {
                return <span style={{ color: 'black' }}>No realizado</span>
            } else if (value == 'PAYMENT') {
                return <span style={{ color: 'green' }}>Pagado</span>
            } else if (value == 'PARCIAL') {
                return <span style={{ color: 'orange' }}>Pago parcial</span>
            } else if (value == 'ERROR') {
                return <span style={{ color: 'red' }}>Error en el pago</span>
            } else if (value == 'FIXED') {
                return <span style={{ color: 'green' }}>Regularizado</span>
            } else {
                return <></>
            }
        },
        // Estado mapeado 1:1 con SuscriptionState del backend.
        rentalState: (value, object) => {
            if (value == 'PENDINGACCEPT') {
                return (
                    <span style={{ color: 'black' }}>
                        Pendiente de aceptación
                    </span>
                )
            } else if (value == 'ACCEPT') {
                return <span style={{ color: 'black' }}>Aceptado</span>
            } else if (value == 'PROBLEMFIANCE') {
                return (
                    <span style={{ color: 'red' }}>
                        Problema con la preautorización
                    </span>
                )
            } else if (value == 'START') {
                return <span style={{ color: 'green' }}>Iniciado</span>
            } else if (value == 'END') {
                return <span style={{ color: 'green' }}>Finalizado</span>
            } else if (value == 'CANCEL') {
                if (object['cancelReason'] == 'PAYMENT_TIMEOUT') {
                    return (
                        <span style={{ color: 'red' }}>Cancelado (impago)</span>
                    )
                }
                return <span style={{ color: 'orange' }}>Cancelado</span>
            } else {
                return <></>
            }
        },
        start: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        end: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        start_real: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        end_real: (value, object) => {
            if (value) {
                return (
                    <>{moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')}</>
                )
            }
        },
        billed: (value, object) => {
            if (object['idBill']) {
                return (
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: '#83c63b',
                            color: 'white',
                        }}
                        onClick={() => {
                            billService.print(
                                object['idBill'],
                                'Factura-Rent-' + object['id'] + '.pdf',
                                (data, error) => {}
                            )
                        }}
                    >
                        {' '}
                        <FileDownloadIcon />
                    </Button>
                )
            } else {
                return <></>
            }
        },
    }

    const conditionDelete = (rent) => {
        var isGenerate =
            rent &&
            rent.id &&
            rent.rentalState != '' &&
            rent.rentalState == 'CANCEL'
        return isGenerate
    }
    return (
        <CrudTable
            service={service}
            urledit={'/rental/edit/'}
            urlnew={'/rental/new/'}
            filter={initFilter}
            hiddenButton={true}
            deleteaction={false}
            conditionDelete={conditionDelete}
            editable={true}
            paintCell={paintCell}
            notexport={true}
            i18n={'rent'}
            fieldstable={[
                'user.email|user.name|user.lastname',
                'suscription.car.brand|suscription.car.model|suscription.car.number',
                'modality',
                'rentalState',
                'paymentState',
                'start',
                'end',
                'total',
                'km_real',
                'billed',
            ]}
            labels={{
                'user.email|user.name|user.lastname': 'Conductor',
                'suscription.car.brand|suscription.car.model|suscription.car.number':
                    'Vehículo',
            }}
            estructureForm={createEstructureFilter}
            haveother={true}
            othersPanel={<PanelSus />}
        />
    )
}
